export const curatorRoute = '/curator'
